import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FeedbackTO, FeedbackType, Page } from 'features/feedback/shared/feedback.types';

export type MineTab = 'ALL' | FeedbackType;

interface Slice {
  items: FeedbackTO[];
  tab: MineTab;
  loading: boolean;
  lastDeleted: FeedbackTO | null;
}

const getInitialState = (): Slice => ({ items: [], tab: 'ALL', loading: false, lastDeleted: null });

const mineSlice = createSlice({
  name: 'mine',
  initialState: getInitialState(),
  reducers: {
    mineGet: (s, _action: PayloadAction<MineTab>) => {
      s.loading = true;
    },
    mineSet: (s, { payload }: PayloadAction<Page<FeedbackTO>>) => {
      s.loading = false;
      s.items = payload.content;
    },
    mineError: (s) => {
      s.loading = false;
    },
    setTab: (s, { payload }: PayloadAction<MineTab>) => {
      s.tab = payload;
    },
    deleteItem: (s, { payload }: PayloadAction<number>) => {
      s.lastDeleted = s.items.find((i) => i.id === payload) ?? null;
      s.items = s.items.filter((i) => i.id !== payload);
    },
    deleteRollback: (s, { payload }: PayloadAction<FeedbackTO>) => {
      if (!s.items.some((i) => i.id === payload.id)) s.items.unshift(payload);
    },
  },
});

export default mineSlice;
export const mineReducer = mineSlice.reducer;
export const mineActions = mineSlice.actions;
